import { render, staticRenderFns } from "./Bon.vue?vue&type=template&id=030efd52&"
import script from "./Bon.vue?vue&type=script&lang=js&"
export * from "./Bon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports